import { render, staticRenderFns } from "./TableConfiguration.vue?vue&type=template&id=87b3e38c&scoped=true"
import script from "./TableConfiguration.vue?vue&type=script&lang=js"
export * from "./TableConfiguration.vue?vue&type=script&lang=js"
import style0 from "./TableConfiguration.vue?vue&type=style&index=0&id=87b3e38c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b3e38c",
  null
  
)

export default component.exports